export enum ButtonType{
    START = "START", END = "END", ACTION = "ACTION"
}